import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgArrowRightFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 5.158c0-1.03 1.224-1.545 1.94-.817l6.727 6.842a1.17 1.17 0 0 1 0 1.634L8.94 19.66c-.716.728-1.94.213-1.94-.817V5.158Z", fill: color }));
};
export default factorySvgIcon(SvgArrowRightFilled);
//# sourceMappingURL=SvgArrowRightFilled.js.map